// Models
import { AssistantConfig } from './ignite-assistant.config';

// Data
import { ASSISTANT_ERROR_MESSAGE, ASSISTANT_GREETING, ASSISTANT_HELP_CATEGORIES, ASSISTANT_INPUT_PLACEHOLDER, ASSISTANT_PRESET_QUESTIONS, ASSISTANT_WAITING_PLACEHOLDER } from './ignite-assistant.data';

/**
 * The main Ignite Growth Platform assistant, as it has always behaved: the
 * audience, campaign, campaign-report, SLA-report, and consumer-profile agent
 * reached at `POST /chat`, rendered globally over the authenticated app.
 *
 * Named for the platform rather than any one domain — it spans all of them, and
 * the docs assistant (`POST /chat/docs`) is the only other surface.
 *
 * Assembled from the existing data constants rather than restating their copy,
 * so parameterizing the panel introduced no second source of truth and changed
 * no wording.
 */
export const IGP_ASSISTANT_CONFIG: AssistantConfig = {
  title: 'Ignite Assistant',
  greeting: ASSISTANT_GREETING,
  presetQuestions: ASSISTANT_PRESET_QUESTIONS,
  helpCategories: ASSISTANT_HELP_CATEGORIES,
  inputPlaceholder: ASSISTANT_INPUT_PLACEHOLDER,
  waitingPlaceholder: ASSISTANT_WAITING_PLACEHOLDER,
  errorMessage: ASSISTANT_ERROR_MESSAGE,
  chatEndpointKey: 'chat',
  product: 'igp',
  assistant: 'app',
  features: { history: true, feedback: true, help: true },
};
